import React from 'react';
import jose from 'assets/images/svg/new-plan/how-work/jose.svg';
import carlos from 'assets/images/svg/autoefectivo-taxi/how-work/carlos-taxi.svg';
import iconCar from 'assets/images/svg/new-plan/how-work/car.svg';
import yape from 'assets/images/svg/new-plan/how-work/yape.svg';
import iconAccident from 'assets/images/svg/new-plan/how-work/down-car.svg';
import like from 'assets/images/svg/new-plan/how-work/like.svg';
import './how-works.scss';
import Tooltip from 'components/tooltip';

interface HowWorkPlanProps {
  isLowerPrice: boolean;
  isTaxi: boolean;
}
const HowWorksLine: React.FC<HowWorkPlanProps> = (props: HowWorkPlanProps) => {
  const { isLowerPrice, isTaxi } = props;

  const TOOLTIP = {
    title: 'Deducible',
    subTitle:
      'Monto que le pagas a la compañía para activar tu seguro cuando tienes un choque.',
  };

  const autoefectivo = (
    <p>
      ¡Hola!
      <br />
      Soy José y tengo 38 años
      <br />
      <span>
        Compré mi seguro vehicular Auto Efectivo
        <br /> por <b>S/ {isLowerPrice ? '29.90' : '65'} mensuales*</b>
      </span>
    </p>
  );

  const autoefectivoTaxi = (
    <p>
      ¡Hola!
      <br />
      Soy Carlos y tengo 38 años
      <br />
      <span>
        Compré mi seguro vehicular Auto Efectivo por S/ 95 mensuales (incluidos
        IGV) para proteger mi taxi.
      </span>
    </p>
  );

  const autoefectivoFooter = (
    <p>
      ¡Ahora tengo tranquilidad y seguridad mientras manejo! <br />
      <span>
        Con <b> Servicio de Grúa y Auxilio mecánico ilimitado. </b>
      </span>
    </p>
  );

  const autoefectivoFooterTaxi = (
    <p>
      Ahora manejo tranquilo y con seguridad
      <br />
      <span>
        Con <b> Servicio de Grúa * y Auxilio mecánico ilimitado. </b>
        <br />
        (*) Cubrimos hasta S/750
      </span>
    </p>
  );

  return (
    <div className="how-works">
      <p className="how-works__content__question">
        ¿Quieres saber cómo funciona? <br /> ¡{isTaxi ? 'Carlos' : 'José'} te lo
        explica!{' '}
      </p>
      <div className="how-works__content">
        <div className="how-works__content__info">
          <div className="how-works__content__info--text how-works__content__info--jose">
            <img src={isTaxi ? carlos : jose} alt={isTaxi ? carlos : jose} />
            <div className="how-works__content__info__content">
              {isTaxi ? autoefectivoTaxi : autoefectivo}
            </div>
          </div>
          <div className="how-works__content__info--text how-works__content__info--car">
            <img src={iconAccident} alt={iconAccident} />
            <div>
              <p>
                Te preguntarás, <br />
                ¿Por qué elegí este seguro?{' '}
              </p>
              <ul>
                <li>
                  Por choques me pagan{' '}
                  <b>
                    hasta S/
                    {isLowerPrice ? '700' : '1,000'}
                  </b>{' '}
                  para repararlo como yo prefiera.
                </li>

                <li>
                  {isTaxi ? (
                    <>
                      {' '}
                      Puedo agregar protección para los pasajeros y terceros
                      afectados.{' '}
                    </>
                  ) : (
                    <>
                      Ante el Robo total de mi carro{' '}
                      <b>
                        me pagan{' '}
                        {isLowerPrice ? 'S/10,000' : 'el valor acordado'}
                      </b>
                    </>
                  )}
                </li>
              </ul>
            </div>
          </div>
          <div className="how-works__content__info--text how-works__content__info--machine">
            <img src={like} alt={like} />
            <div>
              <p>¿Por qué me conviene? </p>
              <ul>
                <li>
                  Realicé el pago usando{' '}
                  <img src={yape} alt={yape} className="yape" />
                </li>

                <li>Pago en soles</li>
                <li>
                  Con Auto Efectivo NO PAGAS deducibles
                  <Tooltip title={TOOLTIP.title} subTitle={TOOLTIP.subTitle} />
                </li>
              </ul>
            </div>
          </div>
          <div className="how-works__content__info--text how-works__content__info--image">
            <img src={iconCar} alt={iconCar} />
            {isTaxi ? autoefectivoFooterTaxi : autoefectivoFooter}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowWorksLine;

HowWorksLine.defaultProps = {
  isLowerPrice: false,
  isTaxi: false,
};
